import { API_BASE } from "config/api";
import { withAuthHeaders } from "services/authHeader";
import { getRefreshToken } from "services/tokenStorage";

export const getUserInfo = () => {
  try {
    const user = localStorage.getItem("user");
    if (user) {
      const parsedUser = JSON.parse(user);
      console.log("Parsed user from localStorage:", parsedUser);
      return parsedUser;
    }
    console.warn("No user found in localStorage");
    return null;
  } catch (error) {
    console.error("Failed to parse user info:", error);
    return null;
  }
};
// Now you can call it without await

/**
 * Tell the server the session is over, then let the caller clear local state.
 *
 * Never throws and never hangs: logging out must not be blocked by a slow or
 * unreachable API, so the request is abandoned after `timeoutMs` and the result
 * is reported rather than raised. The refresh token is sent even though the
 * backend is currently stateless, so revocation can be added server-side
 * without touching the client.
 */
export const logout = async ({ timeoutMs = 3000 } = {}) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const refreshToken = getRefreshToken();

    const res = await fetch(new URL("api/auth/logout", API_BASE), {
      method: "POST",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify(refreshToken ? { refresh_token: refreshToken } : {}),
      signal: controller.signal,
    });

    return { ok: res.ok, status: res.status };
  } catch (error) {
    // Offline, aborted, or API_BASE unset — the local sign-out still proceeds.
    return { ok: false, error };
  } finally {
    clearTimeout(timer);
  }
};

export const resetPassword = async (userObj) => {
  const url = new URL("api/users/resetPassword", API_BASE);

  const res = await fetch(url, {
    method: "PATCH",
    headers: withAuthHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
    body: JSON.stringify(userObj),
  });
  const result = await res.json();
  return result;
};
